import "./App.css";

function App() {
  window.location.replace(
    "https://app.dosen.io?org=socialentrepreneursireland&prompt=true"
  );
  return null;
}

export default App;
